module.exports = __webpack_public_path__ + "static/media/empty05_scoping2_anim.ccc469d4.svg";